import { useInvestmentsId } from "@rentablo/api/apiv1";
import { RangeValue } from "@rentablo/components";
import { useHistoricQuotesPerYear } from "../useHistoricQuotesForInvestment";
import { useChartDataBase } from "./useChartDataBase";
import { getDates } from "./getFromDate";
import { mergeHistoricQuotes } from "./mergeHistoricQuotes";

interface Props {
  investmentId?: number;
  range?: RangeValue;
  dataKey1?: string;
  dataKey2?: string;
}
interface Options {
  enabled?: boolean;
}

export const useChartDataByInvestment = (
  { investmentId, range, dataKey1, dataKey2 }: Props,
  { enabled }: Options = { enabled: true }
) => {
  const { fromDate } = getDates(range);

  const {
    data: investment,
    isFetching: investmentIsLoading,
    isPending: investmentIsPending,
  } = useInvestmentsId(
    { id: investmentId! },
    { enabled: !!investmentId && enabled }
  );
  const {
    data: historicQuotes,
    isFetching: historicQuotesIsLoading,
    isPending: historicQuotesIsPending,
  } = useHistoricQuotesPerYear(
    investmentId,
    investment?.tickerSymbolWithCurrency,
    fromDate,
    { enabled }
  );

  const {
    data: chartData,
    securityData,
    isFetching: isChartDataLoading,
    isPending: isChartDataPending,
  } = useChartDataBase(
    {
      isin: investment?.isin,
      range,
    },
    { enabled }
  );

  const isFetching =
    investmentIsLoading || isChartDataLoading || historicQuotesIsLoading;
  const isPending =
    investmentIsPending || isChartDataPending || historicQuotesIsPending;
  const data = mergeHistoricQuotes(chartData, historicQuotes);

  return {
    data,
    securityData,
    isFetching,
    isPending,
  };
};
